export default __webpack_public_path__ + "static/media/do_more_logo_4.6666833e.png";